"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var merch_components_1 = require("@carvana/merch-components");
var react_1 = __importDefault(require("react"));
var react_2 = require("react");
var Card_styles_1 = require("./Card.styles");
var EVTaxCreditContent_1 = __importDefault(require("./EVTaxCreditContent/EVTaxCreditContent"));
var ChipIcon_1 = __importDefault(require("./icons/ChipIcon"));
var Tag_1 = __importDefault(require("../../Tags/Tag"));
function EVTaxCreditCard() {
    var _a = (0, react_2.useState)(false), showAdditionalInfo = _a[0], setShowAdditionalInfo = _a[1];
    return (react_1.default.createElement(Card_styles_1.Card, { "data-qa": "ev-tax-card" },
        react_1.default.createElement(EVTaxCreditContent_1.default, { headerTag: react_1.default.createElement(Tag_1.default, { bigTag: true, blueText: true, border: true, tag: "ev", text: "EV Tax Credit", "data-qa": "ev-credit-tag" }), qualificationCopy: "This vehicle may qualify for the Previously-Owned Clean Vehicle tax credit made available to taxpayers in the Inflation Reduction Act.", showAdditionalInfo: showAdditionalInfo }),
        react_1.default.createElement(merch_components_1.Clickable, { className: "flex w-fit items-center gap-8 text-sm text-blue-2 underline", "data-analytics-id": "EV Credit Modal - Toggle read more", element: "span", onClick: function () { return setShowAdditionalInfo(!showAdditionalInfo); } },
            "Read ",
            showAdditionalInfo ? 'Less' : 'More',
            react_1.default.createElement(ChipIcon_1.default, { className: showAdditionalInfo ? 'rotate-180' : '' }))));
}
exports.default = EVTaxCreditCard;
//# sourceMappingURL=EVTaxCreditCard.js.map